import { LenderName, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';

// PENDING_ACTION_COMPLETE: 'Completar el proceso de solicitud',
// PENDING_ACTION_EVALUATE: 'Hacer click en Evaluar para enviar la solicitud a las entidades financieras.', //FIXME: NON-SENSE
// PENDING_ACTION_PAY: 'Hacer click en Pagar para completar el pago.',
// PENDING_ACTION_UPLOAD_DOCUMENTS: 'Subir los documentos requeridos',
// PENDING_ACTION_REVIEW_DOCUMENTS: 'Revisar los documentos subidos',
// PENDING_ACTION_SIGN_CONTRACT: 'Firmar el contrato digitalmente',
// PENDING_ACTION_PAY_FIRST_INSTALMENT: 'Pagar primera cuota con tarjeta',

export class ActionsMap {
  static async fromPaymentMethodDetail(paymentMethodDetail: LoanPaymentMethodDetailEntity): Promise<Action[] | null> {
    if (paymentMethodDetail.isExpired()) {
      return null;
    }

    const loan = paymentMethodDetail.loan;

    if (!loan) {
      return null;
    }

    if (paymentMethodDetail.status === LoanStatusExternal.INITIAL) {
      return [Action.COMPLETE_ONBOARDING];
    }

    const signAction =
      loan.loanApplicationSelected?.lenderName === LenderName.SANTANDER_CONSUMER
        ? Action.COMPLETE_PROCESS_SANTANDER
        : Action.SIGN_CONTRACT;

    if (paymentMethodDetail.status === LoanStatusExternal.ON_HOLD) {
      if (paymentMethodDetail.hasProviderError === true || !loan.loanApplicationSelected) {
        return [Action.COMPLETE_ONBOARDING, Action.NO_LENDER_REQUEST_ID];
      }
      if (loan.loanApplicationSelected.lenderName === LenderName.SANTANDER_CONSUMER) {
        return [Action.COMPLETE_ONBOARDING, Action.UPLOAD_DOCUMENTS, signAction];
      }
      return [Action.COMPLETE_ONBOARDING, Action.UPLOAD_DOCUMENTS];
    }

    if (paymentMethodDetail.status === LoanStatusExternal.APPROVED) {
      return paymentMethodDetail.doesRequireKyc()
        ? [Action.COMPLETE_ONBOARDING, Action.UPLOAD_DOCUMENTS, Action.COMPLETE_KYC, signAction]
        : [Action.COMPLETE_ONBOARDING, Action.UPLOAD_DOCUMENTS, signAction];
    }

    return null;
  }
}
